







import { Component, Vue } from 'vue-property-decorator'
@Component({ name: 'Layout404' })
export default class NotFoundLayout extends Vue {

}

